/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFilePom = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M6.89 17v-4.87h1.742c.599 0 1.05.138 1.354.415.308.276.462.687.462 1.232 0 .54-.154.952-.462 1.233-.304.277-.755.415-1.354.415H7.93V17zm1.528-4.02h-.49v1.595h.49c.357 0 .61-.06.757-.181.152-.125.228-.33.228-.617 0-.29-.076-.495-.228-.616-.147-.12-.4-.181-.757-.181zm4.783 4.114c-.728 0-1.29-.22-1.688-.657-.393-.442-.59-1.067-.59-1.876 0-.8.2-1.42.597-1.862.397-.443.958-.664 1.681-.664s1.285.221 1.682.664c.398.442.596 1.063.596 1.862 0 .809-.196 1.434-.59 1.876-.392.438-.955.657-1.688.657zm0-.891c.407 0 .708-.141.905-.422.2-.282.301-.688.301-1.22s-.1-.936-.301-1.213c-.197-.28-.498-.422-.905-.422-.406 0-.71.141-.91.422-.197.277-.296.682-.296 1.213s.099.938.295 1.22c.201.281.505.422.911.422zm3.065.797v-4.87h1.093l1.547 3.208 1.528-3.209h1.092V17h-1.032v-3.156l-1.286 2.687h-.644l-1.286-2.647V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFilePom as FilePom };
